// Misi spesial hari besar — tantangan bertema dengan hadiah aksesori Mochi eksklusif.
// Aksesori dari misi ini TIDAK bisa didapat dari naik level; hanya lewat menyelesaikan misi.
export const HOLIDAYS = [
  {
    id: "valentine", label: "Hari Valentine", emoji: "💝", accent: "#e0484d",
    window: { from: [2, 1], to: [2, 17] },
    tagline: "Bulan penuh kasih sayang.",
    mission: { desc: "Selesaikan 1 kencan romantis di bulan kasih sayang.", metric: "completed", target: 1 },
    reward: { id: "heartwand", label: "Tongkat Hati", emoji: "💗" }, bonus: 120,
  },
  {
    id: "kartini", label: "Hari Kartini", emoji: "🌺", accent: "#c25b8a",
    window: { from: [4, 15], to: [4, 25] },
    tagline: "Rayakan semangat R.A. Kartini.",
    mission: { desc: "Selesaikan 2 kencan menjelang Hari Kartini.", metric: "completed", target: 2 },
    reward: { id: "kartiniflower", label: "Bunga Kartini", emoji: "🌺" }, bonus: 150,
  },
  {
    id: "merdeka", label: "HUT Kemerdekaan RI", emoji: "🇮🇩", accent: "#c9363b",
    window: { from: [8, 10], to: [8, 20] },
    tagline: "Semarak 17 Agustus bareng Mochi.",
    mission: { desc: "Selesaikan 3 kencan di bulan kemerdekaan.", metric: "completed", target: 3 },
    reward: { id: "pecimerdeka", label: "Peci Merdeka", emoji: "🎓" }, bonus: 200,
  },
  {
    id: "natal", label: "Natal", emoji: "🎄", accent: "#2e7d4f",
    window: { from: [12, 18], to: [12, 27] },
    tagline: "Kehangatan musim Natal.",
    mission: { desc: "Selesaikan 2 kencan di musim Natal.", metric: "completed", target: 2 },
    reward: { id: "santahat", label: "Topi Santa", emoji: "🎅" }, bonus: 150,
  },
  {
    id: "tahunbaru", label: "Tahun Baru", emoji: "🎆", accent: "#b08d2f",
    window: { from: [12, 28], to: [1, 5] },
    tagline: "Sambut tahun baru dengan kembang api.",
    mission: { desc: "Selesaikan 1 kencan di pergantian tahun.", metric: "completed", target: 1 },
    reward: { id: "fireworks", label: "Kembang Api", emoji: "🎆" }, bonus: 120,
  },
];

export const HOLIDAY_ACC = HOLIDAYS.reduce((acc, h) => {
  acc[h.reward.id] = { label: h.reward.label, emoji: h.reward.emoji, holiday: h.id };
  return acc;
}, {});

// Jumlah kencan selesai — metrik durable untuk progress misi hari besar.
export const holidayProgress = (state) =>
  (state?.bookings || []).filter((b) => b.status === "completed").length;

function inWindow(w, d) {
  const m = d.getMonth() + 1, day = d.getDate();
  const cur = m * 100 + day;
  const from = w.from[0] * 100 + w.from[1];
  const to = w.to[0] * 100 + w.to[1];
  if (from <= to) return cur >= from && cur <= to; // dalam tahun yang sama
  return cur >= from || cur <= to; // melewati pergantian tahun (mis. tahun baru)
}

// id hari besar yang sedang aktif hari ini (jika ada)
export function activeHolidayId(d = new Date()) {
  const h = HOLIDAYS.find((x) => inWindow(x.window, d));
  return h ? h.id : null;
}
